module.exports = __webpack_public_path__ + "static/media/pencil-icon.1a11559d.svg";